<template>
      <v-card width="300" class="ma-2" :loading="isLoading">
        <v-list-item >
          <v-list-item-content>
          <v-list-item-title class="title">{{net.name}}</v-list-item-title>
            <p class="font-weight-black overline">Region: <span class="overline">{{net.region}}</span></p>
            <p class="font-weight-black overline">Last readings: <span class="overline" > {{getSensorReadingDate(net.temperature)}}</span></p>
            <p class="display-1 my-1 text-right" v-if="netReadings">{{getSensorReadingValue(net.temperature)}}&deg;C</p>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="withSensors"/>
        <v-list dense v-if="withSensors">
          <v-list-item v-for="sensor in net.sensors" :key="sensor.sensorId" :v-if="sensor.isEnabled">
            <v-list-item-content v-if="netReadings"  class="overline">
              {{sensor.sensorLabel}}
            </v-list-item-content>
            <v-list-item-content v-else class="text-right">
              {{sensor.sensorLabel}}
              <br>
             {{ '--' }}
            </v-list-item-content>
            <v-list-item-content v-if="netReadings" class="text-right">
              <span class="overline">{{getSensorReadingValue(sensor.sensorId)}} {{sensor.sensorUM}} </span>
            </v-list-item-content>
            <v-list-item-content v-else class="text-right">
              {{ '--' }} {{sensor.sensorUM}}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
</template>
<style scoped="true">
</style>
<script>
import api from '@/api'
export default {
  name: "UserLogin",
  props: ['net', 'withSensors'],
  data: function () { return {
    readings: [],
    netReadings: [],
    isLoading: true
  }},
  created: async function () {
    this.netReadings = await api.getLastNetReadings(this.net.netId)
    this.isLoading = false 
  },
  methods: {
    getSensorReadingValue(sensorId){
      return (this.netReadings.filter((s)=>s.sensorId == sensorId)).length ? this.netReadings.filter((s)=>s.sensorId == sensorId)[0].sensorValue : " -- " 
    },
    getSensorReadingDate(sensorId){
      return (this.netReadings.filter((s)=>s.sensorId == sensorId)).length ? new Date(this.netReadings.filter((s)=>s.sensorId == sensorId)[0].sensorDate).toLocaleString() : " -- " 
    }
  }

}
</script>
